export const USER_INFO_LOADING = 'USER_INFO_LOADING';
export const LOAD_USER_INFO_SUCCESS = 'LOAD_USER_INFO_SUCCESS';
export const LOAD_USER_INFO_FAIL = 'LOAD_USER_INFO_FAIL';




// WEBPACK FOOTER //
// ./src/store/modules/user/actions.ts